import * as React from "react";
import { DbotButtonPresenter } from "./DbotButtonPresenter";
import { InputWrapper } from "./DbotButtonStyles";
import { TextInput } from "common/src/forms/TextInput";
import { useState } from "react";
import { fetchPanelApi } from "static-content/view/api";
import { checkEmail } from "common/src/forms/FormFunctions";

export const DbotButtonContainer = (props) => {
  if (props.button.view.type === "text-input") {
    return <TextInputPanel button={props.button} onClickButton={props.onClickButton} />;
  }
  return DbotButtonPresenter(
    props.button,
    props.onClickButton,
    props.onClickImage,
    props.appMode,
    props.variables,
    props.sequence,
    props.tag,
    props.totalButtons
  );
};

const TextInputPanel = (props) => {
  const isTextArea = props.button.view.verificationType.indexOf("textarea#") !== -1;
  const verificationType = isTextArea
    ? props.button.view.verificationType.replace("textarea#", "")
    : props.button.view.verificationType;
  const emailDomain = window.OPSEEKER_CONFIG.EMAIL_DOMAIN;
  const [value, setValue] = useState(verificationType === "email" && !!emailDomain ? emailDomain : "");
  const [warning, setWarning] = useState(false);
  const panelApi = fetchPanelApi("DBOT_PANEL", DBOT_PANEL_BACKUP);
  const onClickF = () => {
    if (!isValid(value, verificationType)) setWarning(true);
    else props.onClickButton({ ...props.button, textInput: value });
  };
  return (
    <form autoComplete="on" onSubmit={(e) => e.preventDefault()}>
      <InputWrapper>
        <TextInput
          value={value}
          setValue={(v) => {
            if (verificationType !== "email" || !emailDomain) return setValue(v);
            if (v.substring(v.length - emailDomain.length) !== emailDomain) return;
            setValue(v);
          }}
          showWarning={warning}
          label={""}
          warningLabel={props.button.view.warning}
          isTextArea={isTextArea}
          subLabel={""}
          placeholder={props.button.view.payload}
          type={"text"}
          isEmail={verificationType === "email"}
        />
        <button type="button" onClick={onClickF}>
          {panelApi.get("INPUT_BUTTON")}
        </button>
      </InputWrapper>
    </form>
  );
};

const isValid = (value, verificationType) => {
  if (!verificationType) return true;
  if (verificationType === "email") return checkEmail(value);
  else if (verificationType.startsWith("int")) {
    const parsedValue = parseFloat(value);
    if (isNaN(parsedValue) || (parsedValue | 0) !== parsedValue) return false;
    if (verificationType.includes("#")) {
      const split = verificationType.split("#");
      const lowerLimit = parseInt(split[1]);
      const higherLimit = parseInt(split[2]);
      return lowerLimit <= parsedValue && higherLimit >= parsedValue;
    } else return true;
  } else if (verificationType === "number") {
    return !isNaN(value);
  }
  return true;
};

export const DBOT_PANEL_BACKUP = {
  code: "DBOT_PANEL",
  items: [{ code: "INPUT_BUTTON", value: "Enviar" }],
};
